<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <div class="cat-image">
        <img src="../assets/mygo.png" alt="MyGO" class="mygo-img">
      </div>
      <h1>哎呀！MyGO了</h1>
      <button class="back-home" @click="goHome">
        <span class="cat-paw">🐾</span> 返回首页
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      window.location.href = '/';
    }
  }
}
</script>

<style scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f9f9f9;
  background-image: url('../assets/bg.png');
  background-repeat: repeat;
}

.not-found-content {
  background-color: #fff;
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  animation: fadeIn 0.5s ease-in;
}

.error-code {
  font-size: 80px;
  font-weight: bold;
  color: #e0e0e0;
  margin-bottom: 20px;
}

.cat-image {
  margin: 20px 0;
}

.mygo-img {
  max-width: 150px;
  animation: sadCatWiggle 4s infinite;
}

h1 {
  color: #42b983;
  margin-bottom: 15px;
  font-size: 28px;
}

.back-home {
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.3s, background-color 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.back-home:hover {
  background-color: #3da576;
  transform: translateY(-3px);
}

.back-home:active {
  transform: translateY(0);
}

.cat-paw {
  display: inline-block;
  animation: pawWave 2s infinite;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes pawWave {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(20deg); }
  50% { transform: rotate(0deg); }
  75% { transform: rotate(-20deg); }
  100% { transform: rotate(0deg); }
}

@keyframes sadCatWiggle {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(-5deg); }
  50% { transform: rotate(0deg); }
  75% { transform: rotate(5deg); }
  100% { transform: rotate(0deg); }
}
</style>
